import { render } from "./MessageForm.vue?vue&type=template&id=1b9bd0b5"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"
script.render = render

export default script